import { householdConstants } from "@constants";

const initalState = {
  update: {
    processing: false,
    fail: null
  },
  getEdit: {
    loading: false,
    fail: null
  },
  setting: {
    processing: false
  }
};

export const household = (state = initalState, action) => {
  switch (action.type) {
    case householdConstants.EDIT_HOUSEHOLD_REQUEST:
      return {
        ...state,
        update: {
          ...initalState.update,
          processing: true
        }
      };
    case householdConstants.EDIT_HOUSEHOLD_SUCCESS:
      return {
        ...state,
        update: {
          ...initalState.update,
          processing: false
        }
      };
    case householdConstants.EDIT_HOUSEHOLD_FAILURE:
      return {
        ...state,
        update: {
          ...initalState.update,
          processing: false,
          fail: action.error
        }
      };
    case householdConstants.RESET_EDIT_HOUSEHOLD_SUCCESS:
      return {
        ...state,
        update: initalState.update
      };
    case householdConstants.GET_HOUSEHOLD_EDIT_REQUEST:
      return {
        ...state,
        getEdit: {
          ...initalState.getEdit,
          loading: true
        }
      };
    case householdConstants.GET_HOUSEHOLD_EDIT_SUCCESS:
      return {
        ...state,
        getEdit: {
          ...initalState.getEdit,
          loading: false
        }
      };
    case householdConstants.GET_HOUSEHOLD_EDIT_FAILURE:
      return {
        ...state,
        getEdit: {
          ...initalState.getEdit,
          loading: false,
          fail: action.error
        }
      };
    case householdConstants.RESET_HOUSEHOLD_EDIT_SUCCESS:
      return {
        ...state,
        getEdit: initalState.getEdit
      };
    case householdConstants.SETTING_HOUSEHOLD_USER_CONFIG_REQUEST:
      return {
        ...state,
        setting: {
          ...initalState.setting,
          processing: true
        }
      };
    case householdConstants.SETTING_HOUSEHOLD_USER_CONFIG_DONE:
      return {
        ...state,
        setting: {
          ...initalState.setting,
          processing: false
        }
      };
    default:
      return state;
  }
};
